export const NavItemWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="flex flex-shrink-0">
      <div className="group relative flex size-[40px] w-full flex-row items-center gap-x-3 rounded-md p-2 hover:bg-bg-2">
        {children}
      </div>
    </div>
  )
}
